import { Row, Col, DatePicker, Space, Button, message } from 'antd'
import React from 'react'
import { ClockCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';

class CreateSchedultPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = { datetimeInput: "", selectedSchedule: null }
    }
    componentDidMount() {
        const { selectedSchedule } = this.props;
        if (selectedSchedule) {
            this.setState({ datetimeInput: selectedSchedule.ExecuteTime, selectedSchedule: selectedSchedule })
        }
        else {
            this.setState({ datetimeInput: "", selectedSchedule: null })
        }
    }
    onChange = (value, dateString) => {
        // console.log('Selected Time: ', value);
        // console.log('Formatted Selected Time: ', dateString);

        this.setState({ datetimeInput: dateString })
    }

    onOk = (value) => {
        // console.log('onOk: ', value);
    }

    disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().subtract(1, "day");
    }

    onSaveClicked = () => {
        if (this.state.datetimeInput === "") {
            message.warning("Please select date and time for your content to be published")
            return;
        }



        const { requestServerPost, usertoken, onComplete = () => { }, screendata, selectedSchedule } = this.props;




        if (selectedSchedule) {

            if (this.state.datetimeInput === selectedSchedule.ExecuteTime) {
                message.warning("No changes have been made")
                return;
            }

            const params = new FormData();
            // console.log("screendata " + JSON.stringify(screendata))
            params.append("scheduleid", selectedSchedule.ScheduleID)
            params.append("executetime", this.state.datetimeInput)
            params.append("schedulestatus", "1")

            requestServerPost("update_schedule_publish", params, {}, (response) => {
                onComplete();
            }, usertoken);
        }
        else {
            const params = new FormData();

            params.append("brandid", screendata.BrandID)
            params.append("branchid", screendata.BranchID)
            params.append("screenid", screendata.ScreenID)
            params.append("executetime", this.state.datetimeInput)
            params.append("schedulestatus", "1")

            requestServerPost("create_schedule_publish", params, {}, (response) => {
                onComplete();
            }, usertoken);
        }

    }

    // disabledTime = (current) => {
    //     // Can not select days before today and today
    //     if (moment().date === current.date)
    //     {
    //         return {
    //             disabledHours: () => range(0, 24).splice(4, 20),
    //             disabledMinutes: () => range(30, 60),
    //             disabledSeconds: () => [55, 56],
    //         };
    //     }
    //     else {
    //         return null
    //     }
    // }
    render() {
        const defaultVal = this.state.datetimeInput === "" ? undefined : moment(this.state.datetimeInput.replace(" ", "T"));
        // console.log("this.state.datetimeInput " + this.state.datetimeInput)
        // console.log(this.state.datetimeInput.replace(" ", "T"))
        return (
            <div className="popupcontentcontainer" style={{ height: "100%" }}>
                <Row style={{ width: "100%", height: "100%", padding: "0px" }}>
                    <Col span={24} style={{ padding: "0px" }} className="center-content">
                        <ClockCircleOutlined style={{ fontSize: "40px" }}></ClockCircleOutlined>
                    </Col>
                    <Col span={24} style={{ padding: "0px" }} className="center-content">
                        <div style={{ fontSize: "16px", fontWeight: 400, lineHeight: "18px", width: "250px", margin: "18px 0 0 0", textAlign: "center" }}>
                            Please select date and time for your content to be published
                    </div>
                    </Col>
                    <Col span={24} className="center-content" style={{ padding: "20px" }}>
                        <DatePicker defaultValue={defaultVal} value={defaultVal} disabledDate={this.disabledDate} size="large" showTime onChange={this.onChange} onOk={this.onOk} />

                    </Col>
                    <Col span={24} className="center-content">
                        <Button onClick={this.onSaveClicked} type="primary">Save</Button>

                    </Col>
                </Row>
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(CreateSchedultPopup);
